export default "__VITE_ASSET__336e9742__"